<template>
  <div>
    <v-container v-if='profile && !profile.is_active'>
      <v-alert border='top' type='error'>This account is INACTIVE</v-alert>
    </v-container>
    <wc-page-title :title='title'>
      <template v-slot:rightSide>
        <deactivate
          v-if='profile'
          :profile='profile'
          @update='update'
        ></deactivate>
      </template>
    </wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <basics
            v-if='profile'
            :profile='profile'
            @update='update'
          ></basics>
        </v-col>
        <v-col cols='12' md='4'>
          <profile-details
            v-if='profile'
            :profile='profile'
            @update='update'
          ></profile-details>
        </v-col>
        <v-col cols='12' md='4'>
          <confidential
            v-if='profile'
            :profile='profile'
            @update='update'
          ></confidential>
        </v-col>
        <v-col cols='12' md='6'>
          <app-access
            v-if='profile'
            :profile='profile'
          ></app-access>
        </v-col>
        <v-col cols='12' md='6'>
          <timesheet-categories
            v-if='profile'
            :profile='profile'
          ></timesheet-categories>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import staffingAPI from '../../api/staffing'
import Basics from './Basics'
import Details from './Details'
import Deactivate from './Deactivate'
import AppAccess from './AppAccess'
import TimesheetCategories from './TimesheetCategories'
import Confidential from './Confidential'

export default {
  name: 'profile-overview',
  data: () => ({
    isLoading: true,
    profile: null
  }),
  computed: {
    title () {
      return this.profile ? this.profile.name_display : ''
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.profile = await staffingAPI.getProfile(this.$route.params.id)
      this.isLoading = false
    },
    async update (profile) {
      this.isLoading = true
      this.profile = await staffingAPI.updateProfile(profile)
      this.isLoading = false
    }
  },
  components: {
    'basics': Basics,
    'profile-details': Details,
    'deactivate': Deactivate,
    'app-access': AppAccess,
    'confidential': Confidential,
    'timesheet-categories': TimesheetCategories
  }
}
</script>
